var riot = require("riot");

riot.tag2('ahv-housing-value-spa', '<div class="container-fluid" id="ahv-housing-value-spa"> <div class="row"> <div class="col-lg-12"> <div show="{!authenticated}"> <ahv-login-form></ahv-login-form> </div> <div show="{authenticated}"> <ahv-housing-value-search-bar></ahv-housing-value-search-bar> <ahv-housing-value-display></ahv-housing-value-display> </div> </div> </div> </div> <ahv-loading-indicator></ahv-loading-indicator>', '', '', function(opts) {
    require("./HousingValueSPAController").init(this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/housingValueSPA/ahv-housing-value-spa.tag
 ** module id = 3
 ** module chunks = 0
 **/